import { render } from "./UpdateSettings.vue?vue&type=template&id=d918ca5e&scoped=true"
import script from "./UpdateSettings.vue?vue&type=script&lang=js"
export * from "./UpdateSettings.vue?vue&type=script&lang=js"

import "./UpdateSettings.vue?vue&type=style&index=0&id=d918ca5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d918ca5e"]])

export default __exports__